var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{staticClass:"d-flex flex-row align-center justify-space-between",staticStyle:{"height":"50px"},attrs:{"width":_vm.width,"tile":"","flat":""}},_vm._l((_vm.timeLineLabels),function(label,i){return _c('div',{key:label.stateName,staticClass:"d-flex flex-row align-center"},[_c('div',{class:[
        label.color,
        'd-flex',
        'align-center',
        'justify-center',
        'white--text',
        'text-caption'
      ],staticStyle:{"border-radius":"10px","width":"20px","height":"20px"}},[_vm._v(" "+_vm._s(i + 1)+" ")]),_c('div',{staticClass:"text-caption ml-1"},[_vm._v(" "+_vm._s(_vm.rentalStatusToGerman(label.stateName))+" ")]),(label.stateName !== 'DONE' && label.stateName !== 'CANCELLED')?_c('v-divider',{staticClass:"mx-1",style:({ width: '20px' })}):_vm._e()],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }